import { useEffect } from 'react';
import { Platform } from 'react-native';

type Options = {
  className?: string;
  snapType?: string;
  snapAlign?: string;
};

const useCSSScrollSnap = (options?: Options) => {
  const snapOptions: Options = {
    ...{
      className: 'rnw-scroll-snap',
      snapType: 'x mandatory',
      snapAlign: 'center',
    },
    ...options,
  };

  const styleElementName = 'rnw-scroll-snap-custom-css';

  useEffect(() => {
    if (Platform.OS === 'web' && document) {
      if (!document.querySelector(`[data-name="${styleElementName}"]`)) {
        const style = document.createElement('style');

        style.setAttribute('data-name', styleElementName);
        style.textContent = `.${snapOptions.className}-container{scroll-snap-type:${snapOptions.snapType};scroll-behavior: smooth}.${snapOptions.className}-item{scroll-snap-align:${snapOptions.snapAlign}}`;

        document.head.appendChild(style);
      }
    }
  }, []);
};

export default useCSSScrollSnap;
